import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    agreementRemovedKpiList: [],
    overallRemovedKpiList: [],
    secondaryRemovedKpiList: [],
    correlationRemovedKpiList: [],
    claimsRemovedKpiList: [],
    justRightRemovedKpiList: [],
    fragranceMetricsRemovedKpiList: [],
    preferenceRemovedKpiList: [],
    fragranceAssociationRemovedKpiList: [],
};

export const analysisKpiStore = createSlice({
    name: "analysisKpiStore",
    initialState,
    reducers: {
        loadAgreementRemovedKpiListState: (state, action) => {
            state.agreementRemovedKpiList = action.payload;
        },
        loadOverallRemovedKpiListState: (state, action) => {
            state.overallRemovedKpiList = action.payload;
        },
        loadSecondaryRemovedKpiListState: (state, action) => {
            state.secondaryRemovedKpiList = action.payload;
        },
        loadCorrelationRemovedKpiListState: (state, action) => {
            state.correlationRemovedKpiList = action.payload;
        },
        loadClaimsRemovedKpiListState: (state, action) => {
            state.claimsRemovedKpiList = action.payload;
        },
        loadJustRightRemovedKpiListState: (state, action) => {
            state.justRightRemovedKpiList = action.payload;
        },
        loadFragranceMetricsRemovedKpiListState: (state, action) => {
            state.fragranceMetricsRemovedKpiList = action.payload;
        },
        loadPreferenceRemovedKpiListState: (state, action) => {
            state.preferenceRemovedKpiList = action.payload;
        },
        loadFragranceAssociationRemovedKpiListState: (state, action) => {
            state.fragranceAssociationRemovedKpiList = action.payload;
        },

        resetAnalysisKpiStoreState: () => initialState,
    },
});

export const {
    loadAgreementRemovedKpiListState,
    loadOverallRemovedKpiListState,
    loadSecondaryRemovedKpiListState,
    loadCorrelationRemovedKpiListState,
    loadClaimsRemovedKpiListState,
    loadJustRightRemovedKpiListState,
    loadFragranceMetricsRemovedKpiListState,
    loadPreferenceRemovedKpiListState,
    loadFragranceAssociationRemovedKpiListState,
    resetAnalysisKpiStoreState,
} = analysisKpiStore.actions;

export default analysisKpiStore.reducer;
